import { render, staticRenderFns } from "./ResourceStatistics.vue?vue&type=template&id=4807816e"
import script from "./ResourceStatistics.vue?vue&type=script&lang=js"
export * from "./ResourceStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports